import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Tag,
  Tooltip,
  Image,
  Checkbox,
  Select,
  Modal,
} from "antd";

import startCase from "lodash/startCase";
import capitalize from "lodash/capitalize";
import { Typography } from "antd";
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  ExportOutlined,
  DisconnectOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import ScreenForm from "../components/Screens/ScreenForm";
import PreviewPlaylist from "../components/Playlists/PreviewPlaylist";
import axios from "axios";
import Link from "antd/es/typography/Link";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import { useNavigate, useLocation } from "react-router-dom";

import ConnectedIcon from "../assets/connected.png";
import DisconnectedIcon from "../assets/not-connected.png";
import RequirePermission from "../components/Common/RequirePermission";
import LocationFilter from "../components/Common/LocationFilter";
import CityFilter from "../components/Common/CityFilter";
const { Title } = Typography;
const { Option } = Select;

const Screens = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [screens, setScreens] = useState([]);
  const [editingScreen, setEditingScreen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [createPermission, setCreatePermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [playlists, setPlaylists] = useState([]);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewingPlaylistId, setPreviewingPlaylistId] = useState(null);
  const initialCity = queryParams.get("city")
    ? Number(queryParams.get("city"))
    : "";
  const initialLocation = queryParams.get("location")
    ? Number(queryParams.get("location"))
    : "";
  const initialStatus = queryParams.get("status") || "";
  const initialOrientation = queryParams.get("orientation") || "";
  const initialPlaylistFilter = queryParams.get("playlist")
    ? Number(queryParams.get("playlist"))
    : "";
  const [selectedLocation, setSelectedLocation] = useState(initialLocation);
  const [selectedCity, setSelectedCity] = useState(initialCity);
  const [locations, setLocations] = useState([]);
  const [cities, setCities] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  const [selectedOrientation, setSelectedOrientation] = useState(initialOrientation);
  const [playlistFilter, setPlaylistFilter] = useState(initialPlaylistFilter);
  const [showFilters, setShowFilters] = useState(
    Boolean(initialCity || initialLocation || initialStatus || initialOrientation || initialPlaylistFilter)
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");

  const setQueryParams = (params) => {
    const searchParams = new URLSearchParams(params);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    const newQueryParams = {
      status: selectedStatus,
      city: selectedCity,
      location: selectedLocation,
      orientation: selectedOrientation,
      playlist: playlistFilter,
      filter: value,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    const newQueryParams = {
      status: value,
      city: selectedCity,
      location: selectedLocation,
      orientation: selectedOrientation,
      playlist: playlistFilter,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  }

  const handleOrientationChange = (value) => {
    setSelectedOrientation(value || "");
    const newQueryParams = {
      status: selectedStatus,
      city: selectedCity,
      location: selectedLocation,
      orientation: value,
      playlist: playlistFilter,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  }

  const handlePlaylistFilterChange = (value) => {
    setPlaylistFilter(value || "");
    const newQueryParams = {
      status: selectedStatus,
      city: selectedCity,
      location: selectedLocation,
      orientation: selectedOrientation,
      playlist: value,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  }

  const handleCityChange = (value) => {
    setSelectedCity(value);
    const filteredLocations = locations
      .filter((location) => location.city_id === value)
      .map((location) => ({
        id: location.id,
        name: location.name,
      }));
    if (filteredLocations.length === 0) {
      setLocationOptions(locations);
    }
    else {
      setLocationOptions(filteredLocations);
    }
    const newQueryParams = {
      status: selectedStatus,
      city: value,
      location: selectedLocation,
      orientation: selectedOrientation,
      playlist: playlistFilter,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleLocationChange = (value) => {
    if (value === "") {
      message.warning("Please select a city first.");
    }
    const newQueryParams = {
      status: selectedStatus,
      city: selectedCity,
      location: value,
      orientation: selectedOrientation,
      playlist: playlistFilter,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setSelectedLocation(value);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setSelectedCity("");
    setSelectedLocation("");
    setSelectedStatus("");
    setSelectedOrientation("");
    setPlaylistFilter("");
    setFilterText("");
    setLocationOptions(locations);
    setCurrentPage(1);
    setQueryParams({ limit: pageSize, page: 1 });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleSelectAllChecked = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    const checked = e.target.checked;
    const newSelectedScreens = {};
    screens.forEach((screen) => {
      newSelectedScreens[screen.id] = checked;
    });
    setSelectedScreens(newSelectedScreens);
    setIsSelectAllChecked(checked);
  };

  const handleSingleCheckboxChange = (e, screenId) => {
    e.stopPropagation(); // Prevent event bubbling
    const newSelectedScreens = {
      ...selectedScreens,
      [screenId]: e.target.checked,
    };
    setSelectedScreens(newSelectedScreens);

    // Check if all are selected
    // const allSelected = Object.values(newSelectedScreens).every(
    //   (isChecked) => isChecked
    // );

    // Check if all checkboxes are selected (only count devices that exist)
    const totalScreens = screens.length;
    const selectedCount = Object.values(newSelectedScreens).filter(Boolean).length;
    const allSelected = totalScreens > 0 && selectedCount === totalScreens;
    setIsSelectAllChecked(allSelected);
  };

  const handleEdit = (record) => {
    setIsModalOpen(true);
    setEditingScreen(record);
  };

  const handleExport = (record) => {
    try {
      const queryParams = {
        status: "",
        connected: "",
        screen: record.id, // or record.screen_id depending on your data
        filter: "",
        limit: 10,
        page: 1,
      };

      const searchParams = new URLSearchParams(queryParams);
      navigate(`/signage-tvs?${searchParams.toString()}`);

      message.success(`Viewing devices connected to screen: ${record.name || record.id}`);

    } catch (error) {
      console.error("Error navigating to devices", error);
      message.error("Failed to navigate to devices");
    }

  };

  const handleDisconnect = async (record) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/api/screens/disconnect`,
        {
          id: record.id,
        }
      )
      const { updated_row_count, message: responseMessage } = response.data.data;

      await fetchData();
      if (updated_row_count === 1) {
        message.success("Screen disconnected successfully");
        await fetchData();
      } else {
        message.warning("Screen is already disconnected");
      }
    } catch (error) {
      console.error("Error disconnecting screen", error);
      message.error("Failed to disconnect screen");
    }
  };

  const toggleCodeView = (record, state) => {
    setScreens((prev) => {
      return prev.map((screen) => {
        if (screen.id === record.id) {
          return { ...screen, showCode: state };
        }
        return screen;
      });
    });
    handleCopy(record.code);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/screens/${id}`
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 1) {
        message.success("Screen deleted");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
      message.error(err?.response?.data?.message || "Failed to delete screen");
    }
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/screens`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
            city: selectedCity,
            location: selectedLocation,
            status: selectedStatus,
            orientation: selectedOrientation,
            playlist: playlistFilter,
          },
        }
      );
      let records = response.data.data.data;
      setTotalRecords(response.data.data.total);
      setScreens(
        records.map((screen) => {
          return { ...screen, showCode: false };
        })
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching screen data", error);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/locations`,
        { params: { limit: 1000 } }
      );
      const location = response.data.data.data;
      let city = [];
      for (let i = 0; i < location.length; i++) {
        city.push({
          id: location[i].city_id,
          name: location[i].city_name,
        });
      };
      const uniqueCities = Array.from(
        new Map(city.map((item) => [item.id, item])).values()
      );
      setLocations(location);
      setCities(uniqueCities);
      if (!selectedCity) {
        setLocationOptions(location);
      }
    } catch (error) {
      console.error("Error fetching locations", error);
    }
  };

  useEffect(() => {
    fetchLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newQueryParams = {
      status: selectedStatus,
      city: selectedCity,
      location: selectedLocation,
      orientation: selectedOrientation,
      playlist: playlistFilter,
      filter: filterText,
      limit: queryParams.get("limit") ?? 10,
      page: queryParams.get("page") ?? 1,
    };

    if (JSON.stringify(newQueryParams) !== JSON.stringify(Object.fromEntries(new URLSearchParams(location.search)))) {
      setQueryParams(newQueryParams);
    };

    setQueryParams(newQueryParams);
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, pageSize, filterText, selectedCity, selectedLocation, selectedStatus, selectedOrientation, playlistFilter]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setCreatePermission(parseInt(permissions["signage.screens_create"]) === 1);
    setDeletePermission(parseInt(permissions["signage.screens_delete"]) === 1);
    setEditPermission(parseInt(permissions["signage.screens_edit"]) === 1);
  }, []);

  useEffect(() => {
    fetchPlaylists();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchStatusUpdates(filterText, pageSize, currentPage);
    }, 10000);

    return () => clearInterval(interval);
  }, [filterText, pageSize, currentPage]);

  const fetchStatusUpdates = async (filter, pageSize, currentPage) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/screens`,
        {
          params: {
            filter,
            limit: pageSize,
            page: currentPage,
          },
        }
      );
      const statusRecords = response.data.data.data;
      setScreens((prevScreens) =>
        prevScreens.map((screen) => {
          const updatedStatus = statusRecords.find((s) => s.id === screen.id);
          return updatedStatus ? { ...screen, ...updatedStatus } : screen;
        })
      );
    } catch (error) {
      console.error("Error fetching screen statuses", error);
    }
  };

  const fetchPlaylists = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/screens/masters`
      );
      const playlists = response.data.data.playlists;
      setPlaylists(playlists); // depends on your API shape
    } catch (error) {
      console.error("Failed to fetch playlists", error);
    }
  };

  const handleAssignPlaylist = async () => {
    if (!selectedPlaylist) {
      message.error("Please select a playlist");
      return;
    }

    const selectedScreenIds = Object.keys(selectedScreens).filter(
      (id) => selectedScreens[id]
    );

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/screens/assign-playlist`,
        {
          screen_ids: selectedScreenIds,
          playlist_id: selectedPlaylist,
        }
      );
      message.success("Playlist assigned successfully");
      setAssignModalOpen(false);
      setSelectedPlaylist(null);
      fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign playlist", error);
      message.error("Failed to assign playlist");
    }
  };

  const handleCopy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      message.success("Copied!");
    } catch (err) {
      message.error("Failed to copy");
      console.error("Clipboard error:", err);
    }
  };

  const handlePreviewPlaylist = async (record) => {
    if (!record.playlist_id) return;
    setPreviewLoading(true);
    setPreviewingPlaylistId(record.playlist_id);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/${record.playlist_id}`
      );
      const playlist = response.data.data;
      setPreviewPlaylist({
        ...playlist,
        media: JSON.parse(playlist.media_details),
      });
      setIsPreviewModalOpen(true);
    } catch (error) {
      message.error("Failed to load playlist preview");
      console.error("Error fetching playlist for preview:", error);
    } finally {
      setPreviewLoading(false);
      setPreviewingPlaylistId(null);
    }
  };

  const columns = [];

  if (editPermission) {
    columns.push({
      title: (
        <Checkbox
          name="selected_screen"
          onClick={handleSelectAllChecked}
          checked={isSelectAllChecked}
        />
      ),
      dataIndex: "id",
      render: (text, record) => (
        <Checkbox
          value={record.id}
          name="selected_screen"
          checked={selectedScreens[record.id] || false}
          onChange={(e) => handleSingleCheckboxChange(e, record.id)}
          onClick={(e) => e.stopPropagation()}
        />
      ),
    });
  }

  columns.push({ title: "Screen Name", dataIndex: "name" });
  columns.push({
    title: "Orientation",
    dataIndex: "orientation",
    render: (text) => <Tag color={text === "portrait" ? "blue" : "green"}>{capitalize(text)}</Tag>,
  });
  columns.push({
    title: "Devices",
    dataIndex: "device_count",
    render: (text) => <span>{text || 0}</span>,
  });
  columns.push({
    title: "Status",
    dataIndex: "connection_status",
    render: (text, record) => (
      <>
        {text === "connected" && (
          <Tooltip
            title={`Connected at ${dayjs(record.connected_at).format(
              "DD-MM-YYYY HH:mm"
            )}`}
          >
            <Image src={ConnectedIcon} preview={false} height={22} />
          </Tooltip>
        )}
        {text === "disconnected" && (
          <Tooltip title={`Disconnected`}>
            <Image src={DisconnectedIcon} preview={false} height={22} />
          </Tooltip>
        )}
      </>
    ),
  });
  columns.push({
    title: "Code",
    dataIndex: "code",
    render: (text, record) => (
      <>
        {record.showCode ? (
          <>
            {text} <EyeOutlined onClick={() => toggleCodeView(record, false)} />
          </>
        ) : (
          <>
            ******{" "}
            <EyeInvisibleOutlined
              onClick={() => toggleCodeView(record, true)}
            />
          </>
        )}
      </>
    ),
  });
  // columns.push({
  //   title: "Regenerate Passcode",
  //   dataIndex: "regenerate_passcode",
  //   render: (text) => (
  //     <Tag color={text === "yes" ? "green" : "red"}>{text}</Tag>
  //   ),
  // })
  columns.push({
    title: "Play URL",
    dataIndex: "slug",
    render: (text) => {
      const link = `${window.location.origin}/connect`;
      return (
        <>
          <Link href={link} target="_blank">
            {link}
          </Link>
          <Button
            icon={<CopyOutlined />}
            onClick={() => handleCopy(link)}
            size="small"
            className="ms-3"
          ></Button>
        </>
      );
    },
  });
  columns.push({
    title: "Location / Playlist",
    dataIndex: "location_name",
    render: (text, record) => {
      return (
        <Space direction="vertical" size={4}>
          {text && (
            <Tag>
              {capitalize(record.location_name)} (
              {record.location_code.toUpperCase()})
              {record.floor !== "" && ` - ${record.floor}`}
            </Tag>
          )}
          {record.playlist_title && (
            <span>
              <Tag>{capitalize(record.playlist_title)}</Tag>
              <Tooltip title="Preview Playlist">
                <Button
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() => handlePreviewPlaylist(record)}
                  loading={previewLoading && previewingPlaylistId === record.playlist_id}
                />
              </Tooltip>
            </span>
          )}
        </Space>
      );
    },
  });
  columns.push({
    title: "Updated At",
    dataIndex: "modified_at",
    render: (text) => (
      <span className="text-small">
        {dayjs(text).format("DD-MM-YYYY HH:mm")}
      </span>
    ),
  });
  columns.push({
    title: "Updated By",
    dataIndex: "updated_by_user",
    render: (text) => {
      return <span className="text-small">{startCase(text)}</span>;
    },
  });

  if (editPermission || deletePermission) {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user && (
            <>
              {editPermission &&
                ([1, 2].includes(user.role_id) || record.created_by === user.id) && (
                  <Tooltip title="Edit">
                    <Button
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => handleEdit(record)}
                    />
                  </Tooltip>
                )}
              {(
                <Tooltip title="Connected Device">
                  <Button
                    size="small"
                    icon={<ExportOutlined />}
                    onClick={() => handleExport(record)}
                  />
                </Tooltip>
              )}
              {(
                <Popconfirm
                  title="Are you sure to disconnect this screen?"
                  onConfirm={() => handleDisconnect(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Disconnect">
                    <Button
                      size="small"
                      type="primary"
                      icon={<DisconnectOutlined />}
                      disabled={record.connection_status === "connected" ? false : true}
                    />
                  </Tooltip>
                </Popconfirm>
              )}
              {deletePermission && (
                <Popconfirm
                  title="Are you sure to delete this screen?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Delete">
                    <Button danger size="small" icon={<DeleteOutlined />} />
                  </Tooltip>
                </Popconfirm>
              )}
            </>
          )}
        </Space>
      ),
    });
  }

  return (
    <RequirePermission permission="signage.screens_view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Screens`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Screens
        </Title>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex gap-4">
            <Button
              type="primary"
              disabled={
                Object.values(selectedScreens).filter(Boolean).length === 0
              }
              onClick={() => setAssignModalOpen(true)}
            >
              Assign Playlist
            </Button>
            <Input.Search
              placeholder="Search screen"
              value={filterText}
              onChange={handleSearch}
              style={{ width: 200 }}
            />
            <Button
              icon={<FilterOutlined />}
              type={showFilters ? "primary" : "default"}
              onClick={() => setShowFilters((prev) => !prev)}
            >
              Filters
              {(selectedCity || selectedLocation || selectedStatus || selectedOrientation || playlistFilter) && (
                <Tag color="blue" style={{ marginLeft: 6, marginRight: 0 }}>
                  {[selectedCity, selectedLocation, selectedStatus, selectedOrientation, playlistFilter].filter(Boolean).length}
                </Tag>
              )}
            </Button>
          </div>

          <Button
            type="primary"
            onClick={() => {
              setEditingScreen(null);
              setIsModalOpen(true);
            }}
          >
            Add New Screen
          </Button>
        </div>

        {showFilters && (
          <div className="d-flex gap-4 mb-3">
            <div>
              <span className="me-2">City:</span>
              <CityFilter cities={cities} citySearch={selectedCity} handleCityChange={handleCityChange} />
            </div>
            <div>
              <span className="me-2">Location:</span>
              <LocationFilter locationOptions={locationOptions} locationSearch={selectedLocation} handleLocationChange={handleLocationChange} />
            </div>
            <div>
              <span className="me-2">Status:</span>
              <Select
                value={selectedStatus}
                showSearch
                onChange={(e) => handleStatusChange(e)}
                style={{ width: 200 }}
                filterOption={(input, option) => {
                  return (option?.children ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                allowClear
              >
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </div>
            <div>
              <span className="me-2">Orientation:</span>
              <Select
                value={selectedOrientation}
                onChange={(e) => handleOrientationChange(e)}
                style={{ width: 160 }}
                allowClear
              >
                <Option value="landscape">Landscape</Option>
                <Option value="portrait">Portrait</Option>
              </Select>
            </div>
            <div>
              <span className="me-2">Playlist:</span>
              <Select
                value={playlistFilter}
                showSearch
                onChange={(e) => handlePlaylistFilterChange(e)}
                style={{ width: 200 }}
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "").toString().toLowerCase().includes(input.toLowerCase())
                }
              >
                {playlists.map((playlist) => (
                  <Option key={playlist.id} value={playlist.id}>{playlist.title}</Option>
                ))}
              </Select>
            </div>
            <div>
              <Button onClick={handleClearFilters}>Clear Filters</Button>
            </div>
          </div>
        )}

        <Table
          loading={loading}
          columns={columns}
          dataSource={screens}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} screen`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
        {isModalOpen && (
          <ScreenForm
            isModalOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            editingScreen={editingScreen}
            handleUpdateList={() => fetchData()}
          />
        )}
        <Modal
          title="Assign Playlist"
          open={assignModalOpen}
          onCancel={() => {
            setAssignModalOpen(false);
            setSelectedPlaylist(null);
          }}
          onOk={handleAssignPlaylist}
          okText="Assign"
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a playlist"
            value={selectedPlaylist}
            onChange={(value) => setSelectedPlaylist(value)}
          >
            {playlists.map((playlist) => (
              <Select.Option key={playlist.id} value={playlist.id}>
                {playlist.title}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        {isPreviewModalOpen && (
          <PreviewPlaylist
            isModalOpen={isPreviewModalOpen}
            closeModal={() => setIsPreviewModalOpen(false)}
            playlist={previewPlaylist}
          />
        )}
      </div>
    </RequirePermission>
  );
};

export default Screens;
